import pm from './postmessage';

const FrameManager = {
    framePadding: 24,
    registerFrame: function(frame) {
        const self = this;

        pm.send({
            target: frame.contentWindow || window.frames[frame.id],
            type: 'register',
            data: {
                id: frame.id,
                framePadding: self.framePadding
            },
            url: frame.src
        });

        pm.bind(frame.id, function(data) {
            const iframe = document.getElementById(data.id);

            if (!iframe) return;

            if (data.height) {
                iframe.style.height = (data.height + self.framePadding).toString() + 'px';
            }

            if (data.redirectTo) {
                document.location.href = data.redirectTo;
            }
        });
    }
};

export default FrameManager;
